/* eslint-disable @typescript-eslint/no-explicit-any */
import { Type, ViewContainerRef } from '@angular/core';

export const render = (
  vcr: ViewContainerRef,
  component: Type<any>,
  inputs?: Record<string, any>,
) => {
  const componentRef = vcr.createComponent(component);
  if (inputs) {
    for (const key of Object.keys(inputs)) {
      componentRef.setInput(key, inputs[key]);
    }
  }
  componentRef.changeDetectorRef.detectChanges();
  const html = componentRef.location.nativeElement.innerHTML;
  componentRef.destroy();
  return html;
};
